<template>
  <!-- <el-tabs
    v-model="activeName"
    @tab-click="handleClick"
  >
    <el-tab-pane
      label="全量策略"
      name="1"
      :disabled="alltype == 2"
    >
      <div class="multi-filter-container">
        <el-form
          :model="exe_form"
          label-width="120px"
          :inline="true"
        >
          <el-row :gutter="22">
            <el-col :span="12">
              <el-form-item label="策略名称:">
                <el-input
                  v-model="exe_form.strategy_name"
                  style="width: 250px"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="类型:">
                <el-radio
                  v-model="exe_form.priority"
                  :label="1"
                >普通</el-radio>
                <el-radio
                  v-model="exe_form.priority"
                  :label="2"
                >紧急</el-radio>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="运作时间">
                <el-date-picker
                  v-model="exe_form.execute_time"
                  type="daterange"
                  style="width: 675px"
                  range-separator="至"
                  start-placeholder="开始日期"
                  value-format="yyyy-MM-dd"
                  end-placeholder="结束日期"
                  :picker-options="startPickerOptions"
                  @change="handleDateChange"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="margin-top: 20px">
          <el-button
            type="info"
            @click="closeThis"
          >取消</el-button>
          <el-button
            type="success"
            @click="logData"
          >确定</el-button>
        </div>

      </div>
    </el-tab-pane>
    <el-tab-pane
      label="条件策略"
      name="2"
      :disabled="alltype == 2"
    >
      <div class="multi-filter-container">
        <el-form
          :model="det_form"
          label-width="120px"
          :inline="true"
        >
          <el-row :gutter="22">
            <el-col :span="12">
              <el-form-item label="策略名称:">
                <el-input
                  v-model="det_form.strategy_name"
                  style="width: 250px"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">

              <el-form-item label="类型:">
                <el-radio
                  v-model="det_form.priority"
                  :label="1"
                >普通</el-radio>
                <el-radio
                  v-model="det_form.priority"
                  :label="2"
                >紧急</el-radio>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="搜索剧名:">
                <el-input
                  v-model="det_form.search_play_name"
                  style="width: 675px"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="拉取条件">
                <el-select
                  v-model="det_form.selectedValues"
                  multiple
                  placeholder="请选择条件"
                  style="width: 675px"
                  @change="handleSelectChange"
                >
                  <el-option
                    v-for="item in strategyWhereOptions"
                    :key="item.where_name"
                    :label="item.where_name"
                    :value="item.where_key"
                    :disabled="det_form.selectedValues.length >= 3 && !det_form.selectedValues.includes(item.value)"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <template v-for="item in filteredConditions">
              <el-col
                :key="item.where_key"
                :span="12"
              >
                <el-form-item :label="item.where_name + ':'">
                  <el-input
                    v-if="item.where_name !== '素材类型'"
                    v-model="item[item.where_key]"
                    style="width: 250px"
                  />
                  <el-radio-group
                    v-else
                    v-model="item[item.where_key]"
                    style="width: 250px"
                    size="small"
                  >
                    <el-radio :label="1">图片</el-radio>
                    <el-radio :label="2">视频</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </template>
            <el-col :span="24">
              <el-form-item label="运作时间">
                <el-date-picker
                  v-model="det_form.execute_time"
                  type="daterange"
                  style="width: 675px"
                  range-separator="至"
                  start-placeholder="开始日期"
                  value-format="yyyy-MM-dd"
                  end-placeholder="结束日期"
                  :picker-options="startPickerOptions"
                  @change="handleDateChangetwo"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="margin-top: 20px">
          <el-button
            type="info"
            @click="closeThis"
          >取消</el-button>
          <el-button
            type="success"
            @click="logData"
          >确定</el-button>
        </div>

      </div>
    </el-tab-pane>
  </el-tabs> -->
  <div>
    <el-form
      :model="det_form"
      label-width="120px"
      :inline="true"
    >
      <el-form-item label="策略名称:">
        <el-input
          v-model="det_form.strategy_name"
          style="width: 450px"
        />
      </el-form-item>
      <el-form-item label="搜索剧名:">
        <el-input
          v-model="det_form.search_play_name"
          style="width: 450px"
        />
      </el-form-item>
      <el-form-item label="拉取页数:">
        <el-input
          v-model="det_form.page_size"
          style="width: 450px"
          type="number"
          min="1"
        />
      </el-form-item>
      <div style="text-align: right;">
        <el-button
          type="info"
          @click="closeThis"
        >取消</el-button>
        <el-button
          type="success"
          @click="logData"
        >确定</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { condition } from '@/api/report/adx'

export default {
  name: 'Details',
  data() {
    return {
      strategyWhereOptions: [],
      selectedConditions: [],
      det_form: {
        strategy_name: null,
        search_play_name: null,
        selectedValues: [],
        priority: 1,
        execute_start: null,
        execute_end: null,
        execute_time: [],
        page_size: 10
      },
      activeName: '2',
      exe_form: {
        strategy_name: '',
        execute_time: null,
        execute_start: null,
        execute_end: null,
        priority: 1
      },
      alltype: null,
      startPickerOptions: {
        disabledDate(time) {
          const today = new Date()
          today.setHours(0, 0, 0, 0) // 清除时间部分
          return time.getTime() < today.getTime() // 禁用今天之前的日期
        }
      }
    }
  },
  computed: {
    filteredConditions() {
      // 普通条件排在前面
      const normal = this.selectedConditions.filter(item => item.where_name !== '素材类型')
      // 素材类型排在最后
      const material = this.selectedConditions.filter(item => item.where_name === '素材类型')
      return [...normal, ...material]
    }
  },
  created() {
    this.optionList()
  },
  methods: {
    // 处理选择变化
    handleSelectChange(val) {
      // 找出新增的选项
      const newValues = val.filter(filed => !this.selectedConditions.some(item => item.where_key === filed))

      // 找出删除的选项
      const removedValues = this.selectedConditions.filter(item => !val.includes(item.where_key)).map(item => item.where_key)

      // 添加新选项
      newValues.forEach(item => {
        const option = this.strategyWhereOptions.find(opt => opt.where_key === item)
        if (option) {
          this.selectedConditions.push({
            where_name: option.where_name,
            where_key: option.where_key,
            [option.where_key]: undefined // 初始化值为undefined
          })
        }
      })

      // 删除取消选择的选项
      this.selectedConditions = this.selectedConditions.filter(item => !removedValues.includes(item.where_key))
    },

    // 提交数据
    logData() {
      // 构建最终数据格式 {material_type: 1, play_num_lt:33}
      if (this.activeName === '1') {
        //      strategy_name: '',
        // execute_time: null,
        // execute_start: null,
        // execute_end: null,
        // priority: 1
        const fom_data = { strategy_name: this.exe_form.strategy_name, execute_start: this.exe_form.execute_start, execute_end: this.exe_form.execute_end, priority: this.exe_form.priority, type: 1 }
        this.$emit('logData', fom_data, false)
      } else {
        const strategy_where = {}
        this.selectedConditions.forEach(item => {
          if (item[item.where_key] !== undefined && item[item.where_key] !== '') {
            strategy_where[item.where_key] = item[item.where_key]
          }
        })

        console.log('提交的数据:', {
          strategy_where,
          strategy_name: this.det_form.strategy_name,
          search_play_name: this.det_form.search_play_name
        })

        this.$emit(
          'logData',
          {
            // strategy_where: strategy_where,
            strategy_name: this.det_form.strategy_name,
            search_play_name: this.det_form.search_play_name,
            page_size: this.det_form.page_size
            // type: 2,
            // execute_start: this.det_form.execute_start,
            // execute_end: this.det_form.execute_end,
            // priority: this.det_form.priority
          },
          true
        )
      }
    },

    // 关闭弹窗
    closeThis() {
      this.$emit('close')
    },

    // 接收编辑数据
    async send(val, alltype) {
      this.alltype = alltype
      this.activeName = String(val.type)
      // eslint-disable-next-line eqeqeq
      if (val.type == 1) {
        console.log('2222', val)
        this.exe_form.priority = val.priority
        this.exe_form.execute_time = [val.execute_start, val.execute_end]
        this.exe_form.execute_start = val.execute_start
        this.exe_form.execute_end = val.execute_end
        this.exe_form.strategy_name = val.strategy_name
      } else {
        // await this.optionList()
        condition().then(response => {
          this.strategyWhereOptions = response.data

          this.det_form.strategy_name = val.strategy_name
          this.det_form.search_play_name = val.search_play_name
          this.det_form.priority = val.priority
          this.det_form.execute_time = [val.execute_start, val.execute_end]
          this.det_form.execute_start = val.execute_start
          this.det_form.execute_end = val.execute_end
          // 确保options已加载
          this.$nextTick(() => {
            // 初始化选中的值
            this.det_form.selectedValues = Object.keys(val.strategy_where)
            // 初始化条件值
            this.selectedConditions = Object.entries(val.strategy_where).map(([whereKey, value]) => {
              // eslint-disable-next-line eqeqeq
              const option = this.strategyWhereOptions.find(opt => opt.where_key == whereKey)
              return {
                where_name: option.where_name,
                where_key: whereKey,
                [whereKey]: value
              }
            })
          })
        })
      }
    },

    // 获取可选条件
    optionList() {
      condition().then(response => {
        this.strategyWhereOptions = response.data
      })
    },
    handleClick(tab, event) {
      console.log(tab, event)
    },
    handleDateChange(val) {
      if (val && val.length === 2) {
        this.exe_form.execute_start = val[0]
        this.exe_form.execute_end = val[1]
      } else {
        this.exe_form.execute_start = ''
        this.exe_form.execute_end = ''
      }
    },
    handleDateChangetwo(val) {
      if (val && val.length === 2) {
        this.det_form.execute_start = val[0]
        this.det_form.execute_end = val[1]
      } else {
        this.det_form.execute_start = ''
        this.det_form.execute_end = ''
      }
    }
  }
}
</script>
<style scoped>
.multi-filter-container {
  padding: 0 32px;
  width: 100%;
  text-align: center;
}
</style>
